import { PAGES } from "#/constants";
import {
  ADD_DEPENDENT_PAGE_INFO,
  COMPLEMENTARY_DATA_PAGE_INFO,
  CONTACT_PAGE_INFO,
  CONTRACT_PAGE_INFO,
  DEPENDENTS_PAGE_INFO,
  DETAILS_PAGE_INFO,
  MY_PLAN_PAGE_INFO,
  NEW_DEPENDENTS_PAGE_INFO,
  PAYMENT_PAGE_INFO,
  PLANS_PAGE_INFO,
} from "./constants";
import { PageInfoPropsConfig } from "./types";

export const PAGE_INFO_CONFIG: PageInfoPropsConfig = {
  [PAGES.PLANS]: PLANS_PAGE_INFO,
  [PAGES.MY_PLAN]: (typePlan) => MY_PLAN_PAGE_INFO(typePlan),
  [PAGES.CONTACT]: (typePlan, companyLabel) =>
    CONTACT_PAGE_INFO(typePlan, companyLabel),
  [PAGES.DETAILS_PLAN]: (typePlan, companyLabel) =>
    DETAILS_PAGE_INFO(typePlan, companyLabel),
  [PAGES.DEPENDENTS]: (conditionalFlag) =>
    DEPENDENTS_PAGE_INFO(conditionalFlag),
  [PAGES.ADD_DEPENDENT]: ADD_DEPENDENT_PAGE_INFO,
  [PAGES.NEW_DEPENDENTS]: NEW_DEPENDENTS_PAGE_INFO,
  [PAGES.PAYMENT]: PAYMENT_PAGE_INFO,
  [PAGES.COMPLEMENTARY_DATA]: COMPLEMENTARY_DATA_PAGE_INFO,
  [PAGES.CONTRACT]: CONTRACT_PAGE_INFO,
};
